import { memo } from 'react'

/**
 * ContactBulkActions - Bulk action bar for selected contacts
 * 
 * @atomic - Single responsibility: bulk actions UI
 * @idempotent - Pure component with React.memo
 * @modular - Reusable bulk actions pattern
 */
const ContactBulkActions = memo(function ContactBulkActions({
  selectedCount,
  onMarkResolved,
  onDelete,
  onClear
}) {
  if (selectedCount === 0) return null

  return (
    <div className="px-6 py-3 bg-blue-50 border-b border-blue-100 flex items-center justify-between">
      <span className="text-sm font-medium text-blue-900">
        {selectedCount} item(s) selected
      </span>
      <div className="flex gap-2">
        <button
          onClick={onMarkResolved}
          className="px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700"
        >
          Mark as Resolved
        </button>
        <button
          onClick={onDelete}
          className="px-3 py-1.5 text-sm bg-red-600 text-white rounded hover:bg-red-700"
        >
          Delete Selected
        </button>
        <button
          onClick={onClear}
          className="px-3 py-1.5 text-sm bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
        >
          Clear Selection
        </button>
      </div>
    </div>
  )
})

export default ContactBulkActions
